var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"fixed-sum-table-row"},[_vm._t("prepend"),_vm._l((_vm.headers),function(header,index){return _c('td',{key:index},[_c('span',[_vm._v(_vm._s(_vm._f("emptyValueAsHyphen")(_vm.values[header.value])))])])}),_vm._t("append")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }